import React, { Component } from 'react';
import Moment from 'react-moment';
import 'moment-timezone';
import { MyGlobal, MyAlert } from '../GlobalContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { Link  } from 'react-router-dom'
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


export class ManifestHistory extends Component {
    static displayName = ManifestHistory.name;

    constructor(props) {
        super(props);
        this.state = { carriers : [], manifests: [], loading: true};
        this.history = props.history;
    }

    componentDidMount() {
        this.getCarriers();
    }
    goto(page) {
        this.history.push(page);
    }

    getCarriers() {
        this.setState({ loading: true, alertMessage: "" });

        fetch(`api/Manifest/GetWHCarrierDetailsForHistory?warehouseId=${MyGlobal.warehouse}`)
            .then(async response => {
                this.setState({ loading: false });
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    console.error(errorText);
                    this.setState({ alertMessage: "Failed to load carriers!!" });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;
                    if (apiResponse) {
                        const data = apiResponse.data;
                        if (apiResponse.success) {
                            this.setState({ carriers: data });
                            if (data && data.length > 0) {
                                this.getManifests(data[0].carrierId);
                            }
                        }
                        else {
                            this.setState({ alertMessage: "Failed to load carriers!!  " + apiResponse.errorMessage });
                        }
                    }
                    else {
                        this.setState({ alertMessage: "Failed to load carriers!!" });
                    }
                }
            })
            .catch(error => {
                this.setState({ alertMessage: error });
            });
    }
    getManifests(selectedCarrierId) {

        this.setState({ loading: true, alertMessage: "" });
        fetch(`api/Manifest/GetManifestHistory?carrierId=${selectedCarrierId}`)
            .then(async response => {

                this.setState({ loading: false });
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    console.error(errorText);
                    this.setState({ alertMessage: "Failed to load Manifests!!" });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;
                    if (apiResponse) {
                        const data = apiResponse.data;
                        if (apiResponse.success) {
                            this.setState({ manifests: data });
                        }
                        else {
                            this.setState({ alertMessage: "Failed to load Manifests!!  " + apiResponse.errorMessage });
                        }
                    }
                    else {
                        this.setState({ alertMessage: "Failed to load Manifests!!" });
                    }
                }
            })
            .catch(error => {
                this.setState({ alertMessage: error });
            });
    }

    render() {

        const pagination = paginationFactory({
            page: 2,
            sizePerPage: 5,
            lastPageText: '>>',
            firstPageText: '<<',
            nextPageText: '>',
            prePageText: '<',
            showTotal: true,
            alwaysShowAllBtns: true
        });

        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";

        const defaultSorted = [{
            dataField: 'DateManifested',
            order: 'desc'
        }];
        const columns = [
            { dataField: 'manifestNumber', text: 'Manifest Number' },
            {
                dataField: 'dateManifested',
                text: 'Date Manifested',
                formatter: (value, row) => {
                    return <Moment format="DD/MM/YYYY HH:mm" >
                        {value}
                    </Moment>
                },
                sort: true
            },
            { dataField: 'manifestedDocketCount', text: 'Orders' },
            {
                dataField: "id",
                text: "",
                formatter: (value, row) => {
                    return <Link className="btn btn-success col-12 mb-2" to={{
                        pathname: "ViewManifest",
                        state: row
                    }}>View Manifest</Link>
                }
            }

        ];

      

        return <div className="container" >
            <Container>
                <Row className="mb-3">
                    <Col xs={9}>
                    </Col>
                    <Col xs={3}>
                        <Link className="btn btn-success col-12 mb-2" to={{ pathname: "Manifesting" }}>Back</Link>
                    </Col>
                </Row>
            </Container>
            {alertMessage}
            {this.state.loading && <div> <em>Loading ... </em></div>}
            <select className="form-select form-control" aria-label=".form-select-lg example"
                onChange={(e) => {
                     this.getManifests(e.target.value )
                }} >
                {this.state.carriers.map(row =>
                    <option key={row.carrierId} value={row.carrierId}>{row.carrierName}</option>
                )}
            </select>
            <br/>
            <BootstrapTable keyField='id' data={this.state.manifests} columns={columns} pagination={pagination} defaultSorted={defaultSorted}  />
            </div>
    }
}
